import Footer from "lib/components/footers/LandingPageFooter";
import Navbar from "lib/components/home/Navbar";
import { useAppRouterParams } from "lib/routeHelpers";
import getPageTitle from "lib/utils/getPageTitle";
import type { ReactElement } from "react";
import { useEffect, useState } from "react";
import { Helmet as Head } from "react-helmet-async";
import styles from "../pages/Home.module.scss";
import AppError from "./AppError";

export interface ErrorPageProps {
  statusCode?: number;
}

export default function ErrorPage({ statusCode = 200 }: ErrorPageProps) {
  const [mounted, setMounted] = useState(false);
  const { code, message, redirectTo } = useAppRouterParams();

  const errorCode = Number(code) || statusCode;
  const redirectPath = redirectTo ? decodeURIComponent(redirectTo) : undefined;

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div style={{ visibility: "hidden" }} />;
  }

  return (
    <div className={styles.wrapper}>
      <Head>
        <title>{getPageTitle("Error")}</title>
      </Head>
      <Navbar />
      <div className="grid-container full-height">
        <div className="grid-column-desktop-6" />
        <div className="grid-column-desktop-6 grid-column-mobile-12">
          <AppError statusCode={errorCode} redirectTo={redirectPath} errorMessage={message} />
        </div>
        <div className="grid-column-desktop-6" />
      </div>
      <Footer />
    </div>
  );
}

export function SentryErrorComponent(): ReactElement {
  return <ErrorPage statusCode={500} />;
}
